import axiosBase from "axios";
import APP_ENV from "../Environment";

const axios = axiosBase.create({
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

export const err_logger = (user_info, err, process_name, params_info) => {
    if (APP_ENV.LOG_OUTPUT) {
        axios.post(APP_ENV.BFF + "/log",{user_info, err, process_name, params_info}).then(
            res => console.log("log success", res)
        ).catch(err => console.error("log failure", err))
    }
};